<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="tw-fill-black dark:tw-fill-white" viewBox="0 0 8 14"><path d="M5.23 6.29a1 1 0 0 1 0 1.42l-4.6 4.58a1 1 0 1 0 1.42 1.42l4.59-4.59a3 3 0 0 0 0-4.24L2.04.29a1 1 0 0 0-1.4 1.42z"/></svg>
</template>
